export default [
  // 题库
  {
    path: '/problem',
    // name: 'problem',
    meta: { title: '题库' },
    component: () => import('@/views/pages/problem/list.vue')
  },
  // 题单
  {
    path: '/problem-list',
    // name: 'problem',
    meta: { title: '题库' },
    component: () => import('@/views/pages/problem_list/list.vue')
  },
  // 题库
  {
    path: '/problem/rank',
    meta: { title: '排行榜' },
    component: () => import('@/views/pages/problem/rank.vue')
  },
  // 题库
  {
    path: '/problem/week',
    meta: { title: '排行榜' },
    component: () => import('@/views/pages/problem/week.vue')
  },
  // 比赛题目
  {
    path: '/problem/:problemID',
    name: 'problem',
    component: () => import('@/views/pages/problem/problem/index.vue'),
    redirect: '/problem/:problemID',
    children: [
      {
        path: '',
        name: '',
        meta: { title: "题目描述" },
        component: () => import('@/views/pages/problem/problem/7_code/title.vue'),
      },
      {
        path: 'comments',
        name: 'comments',
        meta: { title: "评论" },
        component: () => import('@/views/pages/problem/problem/7_code/comments.vue'),
      },
      {
        path: 'solution',
        name: 'solution',
        meta: { title: "题解" },
        component: () => import('@/views/pages/problem/problem/7_code/solution.vue'),
      },
      {
        path: 'result',
        name: 'result',
        meta: { title: "题解" },
        component: () => import('@/views/pages/problem/problem/7_code/result.vue'),
      },
      {
        path: 'submissions',
        name: 'submissions',
        meta: { title: "提交记录" },
        component: () => import('@/views/pages/problem/problem/7_code/submissions.vue'),
      }
    ]
  }
]
